import { UseMutationOptions, useMutation } from 'react-query';

import { ResyncUserRole } from '@pimm/services/lib/sms-workforce/services';
import type { TeamMember } from '../types';

// POST /api/Workforce/TeamMembers/ResyncUserRole — 409s when the employee has
// no linked user. Same whole-record-replace response contract as
// UpdateTeamMember: the resolved value is the complete refreshed record.
export type ResyncUserRoleVars = { employeeId: string };

export const useResyncUserRole = (options?: UseMutationOptions<TeamMember, unknown, ResyncUserRoleVars>) =>
  useMutation({
    mutationFn: async (vars: ResyncUserRoleVars) => (await ResyncUserRole(vars)) as TeamMember,
    ...options,
  });
